"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Sea = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "sea", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ id: "sea", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M2 11.418c2.255 0 4.843-2.529 6.15-3.99a1.146 1.146 0 0 1 1.69.008c1.287 1.462 3.841 3.982 6.16 3.982 2.337 0 4.912-2.558 6.19-4.015a1.132 1.132 0 0 1 1.657-.03c1.354 1.45 4.067 4.045 6.153 4.045V14s-11.7 2.918-14 2.918C13.7 16.918 2 14 2 14v-2.582Z", fill: "#909AB5", fillRule: "evenodd", opacity: ".3" }), (0, jsx_runtime_1.jsx)("path", { d: "M2 14c4.171 0 7-4 7-4s2.733 4 7 4c4.267 0 7-4 7-4s3.105 4 7 4c0 0-3 11-14 11S2 14 2 14Z", fill: "#909AB5", fillRule: "evenodd" })] })) })));
};
exports.Sea = Sea;
